import { request } from "apis/base";
import { CommonParamsType } from "constants/types/common";
import { WarehouseRequestType, WarehouseUpdateRequestType } from "constants/types/warehouse";

export const warehouseApi = {
  getAll: (params?: CommonParamsType) => {
    return request({ url: "/warehouse", method: "GET", params });
  },

  getById: (id: string) => {
    return request({ url: `/warehouse/${id}`, method: "GET" });
  },

  create: (data: WarehouseRequestType) => {
    return request({ url: "/warehouse", method: "POST", data });
  },

  update: (id: string, data: WarehouseUpdateRequestType) => {
    return request({ url: `/warehouse/${id}`, method: "PUT", data });
  },

  delete: (id: string) => {
    return request({ url: `/warehouse/${id}`, method: "DELETE" });
  },
};
